// Beat ses dosyaları repo'da değil, Cloudflare R2'de duruyor.
// Manifest sadece obje yolunu (key) tutar; tam URL burada kurulur ki
// CDN adresi değişirse tek bir env değişkeni yeter, manifest'e dokunmayalım.

const BASE = (process.env.REACT_APP_BEATS_BASE_URL || "").replace(/\/+$/, "");

export function beatUrl(item) {
    if (!item?.key) return null;

    if (!BASE) {
        // Env eksikse sessizce bozulmasın, konsolda görelim.
        console.warn(
            "REACT_APP_BEATS_BASE_URL tanımlı değil — beat sesleri çalmaz. " +
            "Vercel'de ve .env.local içinde tanımlı olmalı."
        );
        return null;
    }

    return `${BASE}/${item.key}`;
}
